export const POI_SOURCE_ID = 'bm-poi-all-pois-data'

export const DEFAULT_MAP_LOCATION = [16.37208, 48.20849] // Vienna

export const DEFAULT_MAP_ZOOM = 7

export const MAP_MAX_ZOOM = 20
